/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { entity } from 'projects/icemedx-lib/src/models/common/entity';
import { contact } from '../common/contact';
import { address } from '../common/address';
import { identification } from '../common/identification';
import { basecode } from '../ehr/subs/basecode';
import { patient } from './patient';
import { IceTypes } from '../icetypes';

export class subscriberindex extends IceEntity {
  subscriber_index_key: string = "";
  subscriber_key: string = "";
  first_name: string = "";
  last_name: string = "";
  sex: string = "";
  dob: any = NaN;
  dod: any = NaN;
  ssn_fedid_num: string = "";
  city: string = "";
  postal_code: string = "";
  identification_code1: string = "";
  identification_code2: string = "";
  identification_code3: string = "";
  communication_number1: string = "";
  communication_number2: string = "";
  communication_number3: string = "";
  additional_name: string = "";
  request_message_key: string = "";
  request_message_date: any = NaN;
  request_message_status: number = IceTypes.trans_status.isNone;
  response_message_key: string = "";
  response_message_date: any = NaN;
  response_message_status: number = IceTypes.trans_status.isNone;
  response_message_log: string = "";

  gettablename(): string {
    return "SUBSCRIBER_INDEX";
  }

  getdisplayname(): string {
    let disply = this.first_name;

    if (disply.length > 0)
      disply += " " + this.last_name;

    return disply;
  }
}
